import { useQuery } from 'react-query';
import { getBillingInvoices } from '../api/getBillingInvoices';

const useBillingInvoices = (user_id) => {
  if (!user_id) {
    return false;
  }
  const result = useQuery('billingInvoices', () => getBillingInvoices(), {
    refetchOnWindowFocus: false,
    staleTime: 50000,
  });
  return result;
};

export default useBillingInvoices;
